/**
 * GSplatRelighting shader chunks adapted from the frozen PlayCanvas implementation.
 *
 * The proxy output chunks intentionally only change alpha: RGB remains the lit proxy color and
 * alpha becomes the coverage mask consumed by the splat fragment hook.
 */
export const GSPLAT_RELIGHTING_MESH_OUTPUT_GLSL = /* glsl */ `
gl_FragColor.a = 1.0;
`

export const GSPLAT_RELIGHTING_MESH_OUTPUT_WGSL = /* wgsl */ `
output.color = vec4f(output.color.rgb, 1.0);
`

export const GSPLAT_RELIGHTING_SPLAT_FRAGMENT_GLSL = /* glsl */ `
uniform sampler2D uRelightMap;
uniform vec4 uScreenSize;
uniform float uRelightBlend;
uniform float uRelightBrightness;
uniform float uRelightBackground;

void modifySplatFragment(vec2 gaussianFootprint, inout vec4 color) {
  vec4 lit = textureLod(uRelightMap, gl_FragCoord.xy * uScreenSize.zw, 0.0);
  vec3 factor = mix(vec3(uRelightBackground), lit.rgb * uRelightBrightness, lit.a);
  color.rgb = mix(color.rgb, color.rgb * factor, uRelightBlend);
}
`

export const GSPLAT_RELIGHTING_SPLAT_FRAGMENT_WGSL = /* wgsl */ `
fn modifySplatFragment(gaussianFootprint: vec2f, color: ptr<function, vec4f>) {
  let lit = textureSampleLevel(
    uRelightMap,
    uRelightMap_sampler,
    pcPosition.xy * uniform.uScreenSize.zw,
    0.0
  );
  let factor = mix(
    vec3f(uniform.uRelightBackground),
    lit.rgb * uniform.uRelightBrightness,
    lit.a
  );
  *color = vec4f(
    mix((*color).rgb, (*color).rgb * factor, uniform.uRelightBlend),
    (*color).a
  );
}
`
